<template>
  <aside
      class="sidenav navbar navbar-vertical navbar-expand-xs sidebar-modern"
      :class="{ 'sidebar-collapsed': isCollapsed }"
      id="sidenav-main"
  >
    <SidenavList :is-collapsed="isCollapsed">
      <!-- Event Banner Slot -->
      <template #event-banner>
        <slot name="event-banner"></slot>
      </template>
    </SidenavList>
  </aside>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import SidenavList from "./SidenavList.vue";

const isCollapsed = ref(false);

const handleSidebarToggle = (event) => {
  if (event.detail && event.detail.source === 'navbar') {
    // Toggle from navbar
    isCollapsed.value = !isCollapsed.value;
  } else {
    // Original sidebar toggle behavior
    isCollapsed.value = !isCollapsed.value;
  }

  // Dispatch event for other components
  document.dispatchEvent(new CustomEvent('sidebar-state-changed', {
    detail: { collapsed: isCollapsed.value }
  }));
};

onMounted(() => {
  // Listen for sidebar toggle from navbar
  document.addEventListener('sidebar-toggle', handleSidebarToggle);
});

onBeforeUnmount(() => {
  document.removeEventListener('sidebar-toggle', handleSidebarToggle);
});
</script>

<style lang="scss" scoped>
.sidebar-modern {
  position: fixed !important;
  left: 0;
  width: 14.625rem;
  margin: 0 !important;
  top: 70px;
  height: calc(100vh - 70px);
  border: none !important;
  border-radius: 0 !important;
  overflow: hidden;
  z-index: 1010 !important;
  box-shadow: 4px 0 12px rgba(0, 0, 0, 0.1);

  // Smoother animation with better timing function
  transition: width 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  will-change: width;

  // Hardware acceleration for smoother performance
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000px;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: -80vw;
    height: 100%;
    background:  linear-gradient(to right, rgb(10, 26, 60), rgba(33, 60, 229)) !important;
    z-index: -1; /* Place behind the content */
  }
}

.sidebar-collapsed {
  width: 70px !important;
}

/* Mobile responsive */
@media (max-width: 1199.98px) {
  .sidebar-modern {
    // Smoother mobile slide animation
    transform: translateX(-100%);
    transition: transform 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    z-index: 1025 !important;
    width: 280px !important;
  }

  .sidebar-modern.mobile-sidebar-open {
    transform: translateX(0);
  }

  // Remove collapsed state transition on mobile
  .sidebar-collapsed {
    width: 280px !important;
  }
}

@media (max-width: 767.98px) {
  .sidebar-modern {
    top: 60px;
    height: calc(100vh - 60px);
  }
}

/* Remove all scrollbars */
.sidebar-modern::-webkit-scrollbar {
  display: none;
}

.sidebar-modern {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

/* Remove all rounded borders globally for sidebar */
* {
  border-radius: 0 !important;
}
</style>